export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const toggleLoading = () => ({
	type: TOGGLE_LOADING
});
